import { Component, computed, inject, model } from '@angular/core';
import { useLocalStorage } from '@/utils/signals/localStorage';
import { InspectionFilterDto, InspectionItemDto, InspectionService, SortDto } from '@artemis-software/wr-api';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-user-dashboard-inspection-overview',
  templateUrl: './user-dashboard-inspection-overview.component.html',
  styleUrls: ['./user-dashboard-inspection-overview.component.scss'],
})
export class UserDashboardInspectionOverviewComponent {
  inspectionMode = useLocalStorage<'upcoming' | 'active' | 'sent'>('inspectionMode', 'active');

  inspectionService = inject(InspectionService);

  isLoading = loader();

  page = model<number>(0);
  pageSize = model<number>(10);
  sort = model<SortDto>({ sort: 'fromTimestamp', order: 'DESC' });

  results = asyncComputed(() => {
    const filter = {
      page: this.page(),
      size: this.pageSize(),
      sort: this.sort()
    } as InspectionFilterDto;
    if (this.inspectionMode() === 'upcoming') {
      return this.inspectionService.getOwnUpcomingInspections(filter);
    } else if (this.inspectionMode() === 'active') {
      return this.inspectionService.getOwnActiveInspections(filter);
    }
    return this.inspectionService.getSentInspections(filter);
  }, undefined, this.isLoading);

  inspectionText = computed(() => {
    if (this.inspectionMode() === 'upcoming') {
      return 'Geplante Rundgänge';
    } else if (this.inspectionMode() === 'active') {
      return 'Rundgänge die momentan bearbeitet werden';
    }
    return 'Abgeschlossene Rundgänge';
  });

  inspections = computed(() => this.results()?.items ?? []);

  inspectionCount = computed(() => this.results()?.totalItems ?? 0);

  readonly getInspectionLink = (inspection: InspectionItemDto) => (['inspection', inspection.id]);
}
